import { Component, ElementRef, HostBinding, HostListener } from "@angular/core";

@Component({
    selector: 'tyt-tooltip-button',
    templateUrl: './tooltip-button.component.html',
    styleUrls: ['./tooltip-button.component.scss']
})
export class TooltipButtonComponent {
    constructor(
        private elementRef : ElementRef
    ) {
    }

    element : HTMLElement;
    underlayElement : HTMLElement;

    ngOnInit() {
        this.element = this.elementRef.nativeElement;
        this.popoutCardContainer = this.element.querySelector('.popout-card-container');
        this.popoutCard = this.element.querySelector('.popout-card-container .popout-card');
        this.popoutContent = this.element.querySelector('.popout-card-container .popout-card .popout-content');
        this.underlayElement = this.element.querySelector('.underlay');
        this.button = this.element.querySelector('button');

        if (typeof window !== 'undefined') {
            document.body.appendChild(this.underlayElement);
            document.body.appendChild(this.popoutCardContainer);

            window.addEventListener('resize', this.resizeListener = () => {
                if (this.isOpen) {
                    this.updatePosition();
                }
            });
        }
    }

    private resizeListener;

    ngOnDestroy() {
        this.underlayElement.remove();
        this.popoutCardContainer.remove();

        if (typeof window !== 'undefined')
            window.removeEventListener('resize', this.resizeListener);
    }

    @HostBinding('class.open')
    isOpen = false;

    close() {
        this.isOpen = false;
    }

    private timeout(time = 0) {
        return new Promise<void>(res => setTimeout(() => res(), time));
    }

    @HostBinding('class.left')
    leftAlign : boolean;
    popoutCardContainer : HTMLElement;
    button : HTMLButtonElement;
    popoutCard : HTMLElement;
    popoutContent : HTMLElement;

    open() {
        this.isOpen = true;
        this.updatePosition();
    }

    async updatePosition() {
        this.leftAlign = false;
        
        let buttonLoc = this.button.getBoundingClientRect();
        this.popoutCardContainer.style.top = `${buttonLoc.top}px`;
        this.popoutCardContainer.style.left = `${buttonLoc.left + buttonLoc.width}px`;
        this.popoutCard.style.maxWidth = `${buttonLoc.left + buttonLoc.width - 10}px`;
        this.popoutContent.style.maxHeight = `${buttonLoc.top - 50}px`;
        // Handle left alignment when needed 

        await this.timeout(0);
        let loc = this.popoutCard.getBoundingClientRect();
        this.leftAlign = loc.left < 0;

        if (this.leftAlign) {
            this.popoutCardContainer.style.top = `${buttonLoc.top}px`;
            this.popoutCardContainer.style.left = `${buttonLoc.left}px`;
            this.popoutCard.style.maxWidth = `${window.innerWidth - buttonLoc.left - 30}px`;
        }

    }
}